module.exports = __webpack_public_path__ + "img/QR_code_icon.0d871715.svg";